import React from 'react';
import AdminLayout from '../components/AdminLayout';

const card = { backgroundColor: '#fff', borderRadius: '12px', padding: '20px', border: '1px solid #f3f4f6', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' };

const PLACEHOLDER_METRICS = [
  { label: 'Calls Made (MTD)', icon: '📞', note: 'Total outbound calls this month' },
  { label: 'Connect Rate', icon: '🔗', note: 'Calls answered / calls made' },
  { label: 'Avg Call Duration', icon: '⏱', note: 'Average minutes per connected call' },
  { label: 'Conversions from Calls', icon: '✅', note: 'Leads converted after a call' },
];

export default function AdminReportsCalls() {
  return (
    <AdminLayout>
      <div style={{ padding: '28px 32px', maxWidth: '1000px', margin: '0 auto' }}>
        <div style={{ marginBottom: '28px' }}>
          <h1 style={{ fontSize: '22px', fontWeight: '700', color: '#111827', marginBottom: '4px' }}>Call Reports</h1>
          <p style={{ fontSize: '13px', color: '#6b7280' }}>Calling platform integration required</p>
        </div>

        {/* Empty state */}
        <div style={{ ...card, textAlign: 'center', padding: '48px 32px', marginBottom: '24px' }}>
          <div style={{ fontSize: '40px', marginBottom: '16px' }}>📞</div>
          <h2 style={{ fontSize: '18px', fontWeight: '700', color: '#111827', marginBottom: '8px' }}>Call reporting coming soon</h2>
          <p style={{ fontSize: '14px', color: '#6b7280', maxWidth: '480px', margin: '0 auto 16px' }}>
            Integrate with your calling platform to populate this report. Once connected, you'll see real-time call metrics and conversion data here.
          </p>
          <p style={{ fontSize: '12px', color: '#9ca3af' }}>
            Compatible with: Aircall, Dialpad, OpenPhone, Twilio, RingCentral
          </p>
        </div>

        {/* Placeholder metric cards */}
        <h3 style={{ fontSize: '13px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '12px' }}>
          Metrics that will be tracked
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
          {PLACEHOLDER_METRICS.map((m) => (
            <div key={m.label} style={{ ...card, opacity: 0.6 }}>
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>{m.icon}</div>
              <div style={{ fontSize: '13px', fontWeight: '700', color: '#374151', marginBottom: '4px' }}>{m.label}</div>
              <div style={{ fontSize: '22px', fontWeight: '800', color: '#d1d5db', marginBottom: '6px' }}>—</div>
              <div style={{ fontSize: '11px', color: '#9ca3af' }}>{m.note}</div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
